import React from 'react';
import { Typography, Container, Button } from '@mui/material';
import { styled } from '@mui/system';
import { ReactComponent as Svg } from '../img/denegado.svg';
import { Navigate, useNavigate } from 'react-router-dom';

const RootContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #001A37; /* Color primario */
`;

const ContentContainer = styled(Container)`
  text-align: center;
  color: #fff; /* Color de texto */
  margin-top: 30px;
`;

const ButtonContainer = styled('div')`
  margin-top: 20px;
`;

const AccesoDenegado = () => {
    const navigate = useNavigate()
    const handleGoBack = () => {
        navigate("/");
    };

    return (
        <RootContainer>
            <Svg style={{ width: '60%', marginBottom: '10px', height: '40%' }} />
            <ContentContainer>
                <Typography variant="h2" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                    Acceso denegado
                </Typography>
                <Typography variant="subtitle1">
                    Lo sentimos, no tienes permiso para acceder a este portal.
                </Typography>
                {/* <ButtonContainer>
                    <Button variant="contained" color="secondary" onClick={handleGoBack}>
                        Volver atrás
                    </Button>
                </ButtonContainer> */}
            </ContentContainer>
        </RootContainer>
    );
};

export default AccesoDenegado;